import gql from "graphql-tag";

export default gql`
  query User($id: ID!) {
    User(id: $id) {
      id
      email
      firstName
      lastName
      phoneNumber
      company {
        id
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Queries/GetUserDetails.ts